The details of a student's degree.
